import React from 'react';

import { Box } from '@mui/material';

import { ProgressBarSpinner } from '@components/spinners/ProgressBarSpinner';

import type { FullPageLoadingSpinnerProperties } from './FullPageLoadingSpinner.types';

export const FullPageLoadingSpinner: React.FC<
  FullPageLoadingSpinnerProperties
> = () => {
  return (
    <Box
      data-testid='full_page_loading_spinner'
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        height: '100vh'
      }}>
      <ProgressBarSpinner
        size='95'
        barColor='primary'
        borderColor='secondary'
        isLoading
      />
    </Box>
  );
};
